import {
    createColumnDate,
    createColumnInput,
    createColumnInputNumber,
    createColumnSelect,
    createColumnTreeSelect
} from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { putField } from "../../../../utils/form";
import { callRequestDepartment } from "../../storage-location/request/requestor/requestor.section";
import { callDocumentStatus } from "../../storage-location/storage-location/storage-location.section";
import { callReleaseResult, callRequestDoc } from "../../release/release/request/request.section";
import { callHazSpecies } from "../../inform/request/inform-product/inform-product.logic";
import { dateDiffStr } from "../../../../utils/date";
import lodash from "lodash";
import numeral from "numeral";

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("views.report.docType"),
            dataIndexValue: () => i18n.global.t("views.report.release"),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { visible: () => false }
        }),
        createColumnInput({ title: () => i18n.global.t("views.report.approveCode"), dataIndex: "approveCode", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("model.informProduct.refHazObject"),
            dataIndex: "products.refInspectionProduct.refInformProduct.refHazObject.nameTh",
            dataIndexValue: ({ record }) => {
                return record.products?.map(d => d.refInspectionProduct?.refInformProduct?.refHazObject?.nameTh).join("\r\n")
            },
            customRender: ({ record, column }) => <pre>{column.dataIndexValue({ record })}</pre>,
            width: 250
        }),
        createColumnInput({
            title: () => i18n.global.t("model.informProduct.tradeName"),
            dataIndex: "products.refInspectionProduct.refInformProduct.tradeName",
            dataIndexValue: ({ record }) => {
                return record.products?.map(d => d.refInspectionProduct?.refInformProduct?.tradeName).join("\r\n")
            },
            customRender: ({ record, column }) => <pre>{column.dataIndexValue({ record })}</pre>,
            width: 250
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.informProduct.refHazSpecies"),
            dataIndex: "products.refInspectionProduct.refInformProduct.refHazSpecies.value",
            dataIndexValue: ({ record }) => {
                return record.products?.map(d => d.refInspectionProduct?.refInformProduct?.refHazSpecies?.value).join("\r\n")
            },
            customRender: ({ record, column }) => <pre>{column.dataIndexValue({ record })}</pre>,
            inputProp: () => ({ list: callHazSpecies, optLabel: "value" }),
            search: { name: "products.refInspectionProduct.refInformProduct.refHazSpecies.id" },
            align: "center"
        }),
        createColumnDate({
            title: () => i18n.global.t("model.release.refInspection.inspectionDatetime"),
            dataIndex: "refInspection.inspectionDatetime",
            align: "center",
            format: "DD/MM/YYYY HH:mm"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.release.refInspection.refRequestDoc"),
            dataIndex: "refInspection.refRequestDoc.value",
            inputProp: () => ({
                list: ({ searchQuery }) =>
                    callRequestDoc({ searchQuery }).then(d => d.filter(doc => ["02", "16", "17", "18", "19"].includes(doc?.key))),
                optLabel: "value"
            }),
            search: { name: "refInspection.refRequestDoc.id" },
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.release.refResult"),
            dataIndex: "refResult.value",
            inputProp: () => ({ list: callReleaseResult, optLabel: "value" }),
            search: { name: "refResult.id" },
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.refUserCompany"),
            dataIndex: "refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refUserCompany?.refPersonType?.key === "1" ? record.refUserCompany?.companyNameTh : record.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnTreeSelect({
            title: () => i18n.global.t("model.request.refDepartment"),
            dataIndex: "refDepartment.nameTh",
            inputProp: () => ({
                list: () => callRequestDepartment({ refRequestDocKey: "24" }),
                renderLabel: ({ item }) => (
                    <div>
                        {item.fullCode} : {item.nameTh}
                    </div>
                ),
                filterWhere: ({ value }) => [
                    { name: "fullCode", operator: "like", value },
                    { logic: "OR", name: "nameTh", operator: "like", value }
                ],
                treeDefaultExpandAll: true
            }),
            search: { visible: () => false, name: "refDepartment.id" },
            width: 200
        }),
        createColumnDate({ title: () => i18n.global.t("views.report.docEffectiveDate"), dataIndex: "effectiveDate", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("model.haz.expireDate"), dataIndex: "expireDate", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("views.report.docTimeLive"),
            // dataIndexValue: () => "1 เดือน",
            dataIndexValue: ({ record }) => dateDiffStr({ record }), sorter: false,
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("views.report.weight"),
            dataIndex: "qty",
            dataIndexValue: ({ record }) => {
                return record.products.map(d => numeral(lodash.sum(d.productQties.map(d => d.qty || 0))).format("0,0.00")).join("\r\n")
            },
            customRender: ({ record, column }) => <pre>{column.dataIndexValue({ record })}</pre>,
            align: "right",
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnInputNumber({
            title: () => i18n.global.t("views.report.amount"),
            dataIndex: "amount",
            dataIndexValue: ({ record }) => {
                return record.products.map(d => numeral(lodash.sum(d.productQties.map(d => d.amount || 0))).format("0,0.00")).join("\r\n")
            },
            customRender: ({ record, column }) => <pre>{column.dataIndexValue({ record })}</pre>,
            align: "right",
            width: 120,
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callDocumentStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
